import { capitalize } from "common/utils/strings";
import {
  tractorState_GearToJSON as gearToJSON,
  hitchState_HitchCommandToJSON as hitchCommandToJSON,
  TractorState,
} from "protos/rtc/jobs";
import { t } from "i18next";
import { Typography } from "@mui/material";

import React, { FC } from "react";

interface ExpectedTractorStateProps {
  states: TractorState[];
}
export const ExpectedTractorState: FC<ExpectedTractorStateProps> = ({
  states,
}) => {
  return (
    <div className="flex flex-col gap-2">
      {states.map((s, i) => (
        <div key={`state-${i}`}>
          {s.gear && (
            <div className="flex justify-between">
              <Typography>
                {capitalize(t("views.autotractor.taskCriteria.gearStateValid"))}
              </Typography>
              <Typography>{gearToJSON(s.gear)}</Typography>
            </div>
          )}
          {s.hitch && (
            <div className="flex justify-between">
              <Typography>
                {capitalize(
                  t("views.autotractor.taskCriteria.hitchStateValid")
                )}
              </Typography>
              {s.hitch.command && (
                <Typography>{hitchCommandToJSON(s.hitch.command)}</Typography>
              )}
              {s.hitch.position && <Typography>{s.hitch.position}</Typography>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
